import { render, staticRenderFns } from "./ConfirmarReservasComponent.vue?vue&type=template&id=2f7ce320&"
import script from "./ConfirmarReservasComponent.vue?vue&type=script&lang=js&"
export * from "./ConfirmarReservasComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports